export function alignmentKey({
  sourceStandardCode,
  targetStandardCode,
}: {
  sourceStandardCode: string
  targetStandardCode: string
}) {
  return `${sourceStandardCode}-${targetStandardCode}`
}
